import { render, staticRenderFns } from "./StatusClaim.vue?vue&type=template&id=80138670&"
import script from "./StatusClaim.vue?vue&type=script&lang=js&"
export * from "./StatusClaim.vue?vue&type=script&lang=js&"
import style0 from "./StatusClaim.vue?vue&type=style&index=0&id=80138670&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports